<template>
    <div class="m-0">
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="bg-white b-20 m-" style="border:none;">
                    <CRow class="m-1">
                        <CCol sm="12">
                            <h3 class="custom-40px-700 text-center mt-3">ASK AI</h3>
                            <p class="text-center m-2 font-inter font-color-696969 custom-24px-400">How can we help you?</p>
                        </CCol>
                        <CContainer class="mt-5">
                            <CCol sm="12">
                                <CCard class="border-purple-12px" style="width: 80%;margin: 20px auto;" @click="GoToAnswerAi('Show me the top 5 candidates with the highest interview ratings')">
                                    <CRow class="p-3">
                                        <CCol sm="1">
                                            <div class="text-center">
                                                <img src="../assets/img/medal.png" style="max-width:40px;" />
                                            </div>
    
                                        </CCol>
                                        <CCol sm="10">
                                            <label class="custom-16px-400 text-left">Show me the top 5 candidates with the highest interview ratings.</label>
                                        </CCol>
                                        <CCol sm="1">
                                            <div class="text-center mt-2">
                                                <img src="../assets/img/Arrow Right.png" style="max-width:30px;" />
                                            </div>
                                        </CCol>
    
                                    </CRow>
                                </CCard>
    
                                <CCard class="border-blue-12px" style="width: 80%;margin: 20px auto;" @click="GoToAnswerAi('How many users have completed video interviews this month')">
                                    <CRow class="p-3">
                                        <CCol sm="1">
                                            <div class="text-center">
                                                <img src="../assets/img/calendar-tick.png" style="max-width:40px;" />
                                            </div>
    
                                        </CCol>
                                        <CCol sm="10">
                                            <label class="custom-16px-400 text-left">How many users have completed video interviews this month</label>
                                        </CCol>
                                        <CCol sm="1">
                                            <div class="text-center mt-2">
                                                <img src="../assets/icons/ArrowRightBlue.png" style="max-width:30px;" />
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCard>

                                <CCard class="border-lime-12px" style="width: 80%;margin: 20px auto;" @click="GoToAnswerAi('List all the feedback provided by candidates in their interviews.')">
                                    <CRow class="p-3">
    
                                <CCol sm="1">
                                    <div class="text-center">
                                        <img src="../assets/icons/feedback.png" style="max-width:40px;" />
                                    </div>
    
                                </CCol>
                                <CCol sm="10">
                                    <label class="custom-16px-400 text-left">List all the feedback provided by candidates in their interviews.</label>
                                </CCol>
                                <CCol sm="1">
                                    <div class="text-center mt-2">
                                        <img src="../assets/icons/ArrowRightGreen.png" style="max-width:30px;" />
                                    </div>
                                </CCol>
                                </CRow>
                                </CCard>
    
                                <CCard class="border-success-12px" style="width: 80%;margin: 20px auto;" @click="GoToAnswerAi('Which companies have the most active job postings')">
                                    <CRow class="p-3">
                                <CCol sm="1">
                                    <div class="text-center">
                                        <img src="../assets/icons/company.png" style="max-width:40px;" />
                                    </div>
    
                                </CCol>
                                <CCol sm="10">
                                    <label class="custom-16px-400 text-left">Which companies have the most active job postings</label>
                                </CCol>
                                <CCol sm="1">
                                    <div class="text-center mt-2">
                                        <img src="../assets/icons/Arrow RightGreenLight.png" style="max-width:30px;" />
                                    </div>
                                </CCol>
                                </CRow>
                                </CCard>
                                <CCard class="border-orange-12px" style="width: 80%;margin: 20px auto;"  @click="GoToAnswerAi('How many candidates have been shortlisted by companies in the past week?')">
                                    <CRow class="p-3">
                                <CCol sm="1">
                                    <div class="text-center">
                                        <img src="../assets/icons/candidate.png" style="max-width:40px;" />
                                    </div>
    
                                </CCol>
                                <CCol sm="10">
                                    <label class="custom-16px-400 text-left">How many candidates have been shortlisted by companies in the past week?</label>
                                </CCol>
                                <CCol sm="1">
                                    <div class="text-center mt-2">
                                        <img src="../assets/icons/Arrow RightOrange.png" style="max-width:30px;" />
                                    </div>
                                </CCol>
                                </CRow>
                                </CCard>

                                <CCard class="bg-grey-card">
    <CRow class="p-3">
        <CCol sm="1" class="mt-2">
            <img src="../assets/img/Magic Stick 3.png" style="max-width:20px" />
        </CCol>
        <CCol sm="9">
            <input type="text" placeholder="Please write your request here.." class="transparent-input" style="width:100%" v-model="statement"/>
        </CCol>
        <CCol sm="2">
            <div class="text-right">
                <CButton type="button" class="custom-border-purple text-white" @click="GoToAnswerAiByInput()">Send</CButton>
            </div>
        </CCol>
    </CRow>
</CCard>

    
                            </CCol>
                        </CContainer>
    
                    </CRow>
                </CCard>
    
            </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/LoginHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import ToggleCard from '../components/Toggle.vue';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            Names: "",
            statement: "",

        };
    },
    created() {
        AOS.init();
    },
    async mounted() {
      
      try {
        const isAuth = await this.UserAuth();
        if (isAuth) {
          await this.GetInfoUser();
        } else {
          this.GoToLogin();
        }
      } catch (error) {
        this.GoToLogin();
        console.error("Error during authentication:", error);
        // Handle the error here
      }
    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToAnswerAi(statement)
        {
            this.$router.push("AnswerAI?statement=" + statement);
        },
        GoToAnswerAiByInput()
        {
            this.$router.push("AnswerAI?statement=" + this.statement);
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
    }

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>